import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class TinInvalidModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    newBookingStatus: PropTypes.string,
    t: PropTypes.func,
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.open !== nextProps.open) {
      return true;
    }
    return false;
  }

  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        size="small"
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={t('Required Information')} />
        <Modal.Content>
          <Modal.Description>
            <p><strong>Error: Purchaser&#39;s Tax Identification Number must be validated.</strong></p>
            <p>Please complete and validate the purchaser&#39;s Tax Identification Number before changing the unit to {this.props.newBookingStatus} .</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} content={t('Close', { ns: TRANSLATION_FILES.translation })} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(TinInvalidModal);



// WEBPACK FOOTER //
// ./src/containers/modals/TinInvalidModal.jsx